import React, { Component } from "react";
import Sidebar from "../SRUSidebar/SRUSidebar";
import { Card } from "primereact/card";
import { connect } from "react-redux";
import { Toast } from "primereact/toast";
import ScrolltoTop from "../../ScrollTop/ScrollTop";
import axios from "axios";
import { Messages } from "primereact/messages";
import "./SRUReviewAndSend.css";
import { Button } from "primereact/button";
import { ConfirmPopup, confirmPopup } from "primereact/confirmpopup";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { setUserSessionAuthKey } from "../../../Component/commonUtils";
import TranslationFile from "../../15-Translation/locale/Translation_apps.json";
import SRUNavBarHeader from "../SRUNavBarHeader/SRUNavBarHeader";
import Footer_contact_tab from "../../Footerpage/Footer_contact_tab";
import config from "../../../Configuration/Config";
import { Tooltip } from "primereact/tooltip";
import { Helmet } from "react-helmet-async";
import { ProgressSpinner } from "primereact/progressspinner";
import { Checkbox } from "primereact/checkbox";
import moment from "moment";

import { Dialog } from "primereact/dialog";

import { ConfirmDialog } from "primereact/confirmdialog";

let userSessionAuthKeyReturnValue = setUserSessionAuthKey();

const mapStateToProps = (state) => {
  return {
    annualReportType: state.annualReportType.annualReportType.values,
    companyInformation: state.companyInformation.companyInformation.values,
    financialYear: state.financialYear.financialYear,
    sessionDetails: state.sessionDetails.sessionDetails.values,
    login: state.login.login.values,
    sideBarReducer: state.sideBarReducer.sideBarReducer,
    prices: state.prices.prices,
    currentPageName: state.currentPageName.currentPageName,
    payment: state.payment.payment
  };
};

let currentReportGUIDFromUrl = "",
  linkSharedUser,
  sideBarGreenTickPages = [];
let userSelectedLanguage;

class SRUReviewAndSend extends Component {
  constructor(props) {
    super(props);
    this.state = {
      checkoutId: "",
      checkoutPurchaseId: "",
      checkoutAmount: 0,
      showPayementSuccessModal: false,
      showNotification: false,
      loading: false,
      infoFile: [],
      blanketFile: [],
      sideBarStatus: true,
      infoFileText: "",
      currentReportId: "",

      headerResponse: null,

      showSkatterverketButton: false,
      showSkatteverketDialog: false,

      showConfirmReSubmitSkatteverketDialog: false,

      showSkatteverketMaximumDialog: false,
      skatteverketSubmissionCount: 0,
      maximumSkatteverketSubmissionCount: 0
    };
    this.acceptSendToSkatteverket = this.acceptSendToSkatteverket.bind(this);
  }
  copyToClipboardInfo = () => {
    const { infoFile } = this.state;
    const textToCopy = infoFile.join("\n");
    navigator.clipboard
      .writeText(textToCopy)
      .then(() => {
        this.toast.show({
          severity: "success",
          summary: "Copied",
          detail: TranslationFile.CopyInfoFileText[userSelectedLanguage],
          life: 2000
          // icon: "pi pi-file-check"
        });
      })
      .catch((error) => {
        this.toast.show({
          severity: "error",
          summary: "Error",
          detail: "Failed to copy content to clipboard",
          life: 2000
        });
      });
  };
  copyToClipboardBlanket = () => {
    const { blanketFile } = this.state;
    const textToCopy = blanketFile.join("\n");
    navigator.clipboard
      .writeText(textToCopy)
      .then(() => {
        this.toast.show({
          severity: "success",
          summary: "Copied",
          detail: TranslationFile.CopyBlanketFileText[userSelectedLanguage],
          life: 2000
          // icon: "pi pi-file-check"
        });
      })
      .catch((error) => {
        this.toast.show({
          severity: "error",
          summary: "Error",
          detail: "Failed to copy content to clipboard",
          life: 2000
        });
      });
  };

  getAnnualReportSetup = async () => {
    try {
      const rebelSkoolUser = JSON.parse(localStorage.getItem("rebelSkoolUser"));

      const authKey = rebelSkoolUser?.["User-Session-Auth-Key"];

      if (!authKey) {
        console.error("Missing auth key in localStorage");
        return false;
      }

      const { data } = await axios.get(
        "/annualReportRepresentative/getSkatteverketUIConfig",
        {
          headers: {
            "User-Session-Auth-Key": authKey
          }
        }
      );

      console.log("Skatteverket Config API:", data);

      const mode = (data?.mode || "").toUpperCase();

      const environmentMap = {
        TEST: data?.testEnvironment,
        LOCAL: data?.localEnvironment,
        LIVE: data?.liveEnvironment
      };

      const currentEnvironment = environmentMap[mode];

      const isSkatterverketVisible =
        currentEnvironment?.isSentToSkatterverketButtonVisible ?? false;

      console.log("Mode:", mode);
      console.log("isSkatterverketVisible:", isSkatterverketVisible);

      return isSkatterverketVisible;
    } catch (error) {
      console.error("Error:", error?.message || error);
      return false;
    }
  };

  componentWillMount() {
    window.scrollTo(0, 0);

    const user = JSON.parse(localStorage.getItem("rebelSkoolUser") || "{}");
    if (!user?.emailID) {
      this.props.history.push("/income-declaration-2");
      window.location.reload();
    }

    userSelectedLanguage = localStorage.getItem("selectedLanguage");
    userSessionAuthKeyReturnValue = setUserSessionAuthKey();
    const { login, sideBarReducer, payment } = this.props;
    let { companyInformation, sessionDetails, currentPageName, readOnly } =
      this.props;

    this.setState({
      showNotification: false
    });
    window.scrollTo(0, 0);
    let splittedUrl = window.location.href.split("/");
    currentReportGUIDFromUrl = splittedUrl[splittedUrl.length - 2];

    const pages = JSON.parse(
      localStorage.getItem("sruPossibleAccessablePages") || "[]"
    );

    if (!pages.includes("INK2S")) {
      this.props.history.replace(
        "/income-declaration-2/" + currentReportGUIDFromUrl + "/INK2S"
      );
      return;
    }
    window.scrollTo(0, 0);

    currentPageName.values = "Review And Send";
    localStorage.setItem("currentPageName", "Review And Send");

    if (userSessionAuthKeyReturnValue) {
      axios
        .get(
          "/SRUHeader/getHeader?reportGuid=" + currentReportGUIDFromUrl,
          userSessionAuthKeyReturnValue
        )
        .then((response) => {
          if (response.data) {
            let responseDate = response.data;

            if (responseDate != "") {
              this.setState({ currentReportId: responseDate.reportID });
              let reportAccessReq = {
                reportId: responseDate.reportID
              };
              axios
                .post(
                  "/SRUHeader/getAccessStatus",
                  reportAccessReq,
                  userSessionAuthKeyReturnValue
                )
                .then((response) => {
                  switch (response.data) {
                    case 2:
                      linkSharedUser = 2; //Write
                      break;
                    case 3:
                      linkSharedUser = 3; //Read Only
                      break;
                    case 4:
                      linkSharedUser = 4; //No Access
                      break;
                  }

                  if (response.data <= 3) {
                    axios
                      .get(
                        "/SRULines/generateSRUFile?reportId=" +
                          responseDate.reportID,
                        userSessionAuthKeyReturnValue
                      )
                      .then((response) => {
                        axios
                          .get(
                            "/SRUHeader/getHeader?reportGuid=" +
                              currentReportGUIDFromUrl,
                            userSessionAuthKeyReturnValue
                          )
                          .then((response) => {
                            let headerResponse = response.data;
                            const allLines = response.data.infoFile.split("\n");
                            const allBlanketLines =
                              response.data.blanketFile.split("\n");
                            this.setState({
                              headerResponse: headerResponse,
                              infoFile: allLines,
                              blanketFile: allBlanketLines
                            });
                          });
                      });
                    // axios
                    //   .get(
                    //     "/annualReport/pdf?reportGUID=" +
                    //     currentReportGUIDFromUrl,
                    //     {
                    //       responseType: "blob",
                    //     }
                    //   )
                    //   .then((response) => {
                    //     const url = window.URL.createObjectURL(
                    //       new Blob([response.data], { type: "application/pdf" })
                    //     );
                    //     this.setState({
                    //       infoFile: url,
                    //     });
                    //   });
                  }

                  axios
                    .get(
                      "/SRU/getCompletedPages?reportId=" +
                        responseDate.reportID,
                      userSessionAuthKeyReturnValue
                    )
                    .then((response2) => {
                      sideBarReducer.values = response2.data;

                      sideBarReducer.values.push("My Dashboard");
                      sideBarReducer.values.push("Company Information");

                      let getPossibleAccessablePages = localStorage.getItem(
                        "sruPossibleAccessablePages"
                      );
                      let getPossibleAccessablePagesArray = JSON.parse(
                        getPossibleAccessablePages
                      );
                      getPossibleAccessablePagesArray.push("Review And Send");

                      sideBarReducer.values.push("Review And Send");

                      getPossibleAccessablePagesArray = [
                        ...new Set(getPossibleAccessablePagesArray)
                      ];
                      let updatePossibleNavigationPagesListString =
                        JSON.stringify(getPossibleAccessablePagesArray);
                      localStorage.setItem(
                        "sruPossibleAccessablePages",
                        updatePossibleNavigationPagesListString
                      );
                    });
                })
                .catch((error) => {
                  let noAccessURL =
                    "/income-declaration-2/" +
                    currentReportGUIDFromUrl +
                    "/no-access";
                  this.props.history.push(noAccessURL);
                });
            }
            // }

            axios
              .get(
                "/SRU/getCompletedPages?reportId=" + response.data.reportID,
                userSessionAuthKeyReturnValue
              )
              .then((completedStatementTypesResponse) => {
                let sideBarReducerValues = [];
                sideBarReducerValues = completedStatementTypesResponse.data;
                if (linkSharedUser != 3) {
                  sideBarReducerValues.push("Payment");
                }
                sideBarReducer.values = sideBarReducerValues;
                sideBarGreenTickPages = completedStatementTypesResponse.data;
                this.setState({
                  reRender: true
                });

                setTimeout(() => {
                  if (payment.values.checkoutRef != "") {
                    axios
                      .get(
                        "/annualReportPackage/getCheckoutDetailsByRef?checkoutRef=" +
                          payment.values.checkoutRef,
                        userSessionAuthKeyReturnValue
                      )
                      .then((checkoutRefResponse) => {
                        this.setState({
                          loading: false
                        });
                        if (
                          checkoutRefResponse.data != "" &&
                          !checkoutRefResponse.data.isNotificationShown
                        ) {
                          this.setState({
                            showNotification: true
                          });
                          axios
                            .get(
                              "/annualReportPackage/updateNotificationByCheckoutRef?checkoutRef=" +
                                payment.values.checkoutRef,
                              userSessionAuthKeyReturnValue
                            )
                            .then((updateNotifyResponse) => {});
                        }
                      });
                  } else {
                    this.setState({
                      loading: false
                    });
                  }
                }, 3000);
              });
          }
        });
    }
  }
  rowCount = () => {
    const { infoFile } = this.state;
    if (Array.isArray(infoFile)) {
      return infoFile.length;
    }
    return 0;
  };
  componentDidMount() {
    this.msgs1.show([
      {
        severity: "success",
        detail: TranslationFile.Paymentsuccess[userSelectedLanguage],
        sticky: true
      }
    ]);

    this.loadData();
  }
  paymentSuccessModalOnHide() {
    this.setState({
      showPayementSuccessModal: false
    });
  }

  loadData = async () => {
    const result = await this.getAnnualReportSetup();

    this.setState({
      showSkatterverketButton: result
    });
  };

  acceptSendToSkatteverket() {
    this.toast.show({
      severity: "success",
      summary: TranslationFile.SumissionSuccess[userSelectedLanguage],
      detail: TranslationFile.PaymentSubmitToBolags[userSelectedLanguage],
      life: 2000
    });
  }

  next(e) {
    const incomeDeclaration2SRU = "/income-declaration-2/";
    this.props.history.push(
      incomeDeclaration2SRU + currentReportGUIDFromUrl + "/digitalSignature"
    );
  }

  // confirmSubmitToSkatteverket(e) {
  //   confirmPopup({
  //     target: e.currentTarget,
  //     message: "Are you sure you want to send this report to Skatteverket",
  //     icon: "pi pi-check",
  //     accept: this.acceptSendToSkatteverket.bind(this)
  //     // reject
  //   });
  // }

  // handleSkatteverketSubmissionResponse = (responseData) => {
  //   this.setState((prevState) => {
  //     const currentCount =
  //       prevState.headerResponse?.sendToSkatteverketCount || 0;

  //     const newCount = currentCount + 1;

  //     return {
  //       loading: false,
  //       showSkatteverketDialog: true,
  //       skatteverketResponse: responseData,
  //       showConfirmReSubmitSkatteverketDialog: false,

  //       headerResponse: {
  //         ...prevState.headerResponse,
  //         sendToSkatteverketCount: newCount
  //       },

  //       skatteverketSubmissionCount: newCount
  //     };
  //   });
  // };

  handleSkatteverketSubmissionResponse = (responseData) => {
    this.setState({
      showSkatteverketDialog: true,
      skatteverketResponse: responseData,
      showConfirmReSubmitSkatteverketDialog: false
    });
  };
  showWarningsDialogBox = () => {
    this.setState({
      showConfirmReSubmitSkatteverketDialog: true
    });
  };

  // submitToSkatteverket = () => {
  //   this.checkMaximumSubmission();
  // };

  handleSendToSkatteverket = () => {
    const submissionCount = Number(
      this.state.headerResponse?.sendToSkatteverketCount || 0
    );

    if (submissionCount > 0) {
      this.showWarningsDialogBox();
      return;
    }

    this.checkMaximumSubmission();
  };

  // checkMaximumSubmission = () => {
  //   axios
  //     .get(
  //       "/xml/isMaximumSubmissionReached?reportId=" +
  //         this.state.currentReportId,
  //       userSessionAuthKeyReturnValue
  //     )
  //     .then((response) => {
  //       const data = response.data;

  //       const submissionCount = data?.currentSubmittedCount || 0;
  //       const maximumSubmissionCount = data?.maximumSubmissionCount || 0;

  //       this.setState({
  //         skatteverketSubmissionCount: submissionCount,
  //         maximumSkatteverketSubmissionCount: maximumSubmissionCount
  //       });

  //       // Maximum reached
  //       if (submissionCount >= maximumSubmissionCount) {
  //         this.showMaximumSubmissionDialog();
  //         return;
  //       }

  //       // Already submitted - show ReSubmit warning
  //       if (submissionCount > 0) {
  //         this.showWarningsDialogBox();
  //         return;
  //       }

  //       // First submission
  //       this.sendToSkatteverket();
  //     })
  //     .catch((error) => {
  //       console.error("Error checking maximum Skatteverket submission:", error);

  //       this.toast.show({
  //         severity: "error",
  //         summary: "Error",
  //         detail:
  //           error?.response?.data?.message ||
  //           "Unable to check submission limit.",
  //         life: 6000
  //       });
  //     });
  // };

  // sendToSkatteverket = () => {
  //   this.setState({ loading: true });

  //   axios
  //     .post(
  //       "/xml/submitToSkatteverket?reportId=" + this.state.currentReportId,
  //       {},
  //       userSessionAuthKeyReturnValue
  //     )
  //     .then((response) => {
  //       // First show the successful response
  //       this.handleSkatteverketSubmissionResponse(response.data);

  //       // Then immediately get the latest submission count
  //       return axios.get(
  //         "/xml/isMaximumSubmissionReached?reportId=" +
  //           this.state.currentReportId,
  //         userSessionAuthKeyReturnValue
  //       );
  //     })
  //     .then((response) => {
  //       const data = response.data;

  //       const submissionCount = data?.currentSubmittedCount || 0;
  //       const maximumSubmissionCount = data?.maximumSubmissionCount || 0;

  //       this.setState({
  //         skatteverketSubmissionCount: submissionCount,
  //         maximumSkatteverketSubmissionCount: maximumSubmissionCount,

  //         // IMPORTANT: update the object used by your button
  //         headerResponse: {
  //           ...this.state.headerResponse,
  //           sendToSkatteverketCount: submissionCount
  //         }
  //       });
  //     })
  //     .catch((error) => {
  //       this.setState({
  //         loading: false,
  //         showConfirmReSubmitSkatteverketDialog: false
  //       });

  //       console.error(error);
  //     });
  // };

  checkMaximumSubmission = () => {
    axios
      .get(
        "/xml/isMaximumSubmissionReached?reportId=" +
          this.state.currentReportId,
        userSessionAuthKeyReturnValue
      )
      .then((response) => {
        const data = response.data;

        const submissionCount = Number(data?.currentSubmittedCount || 0);
        const maximumSubmissionCount = Number(
          data?.maximumSubmissionCount || 0
        );

        console.log("SKV submission count:", submissionCount);
        console.log("SKV maximum count:", maximumSubmissionCount);

        this.setState(
          {
            skatteverketSubmissionCount: submissionCount,
            maximumSkatteverketSubmissionCount: maximumSubmissionCount
          },
          () => {
            if (
              maximumSubmissionCount > 0 &&
              submissionCount >= maximumSubmissionCount
            ) {
              console.log("MAXIMUM SUBMISSION REACHED");

              this.setState({
                showSkatteverketMaximumDialog: true
              });

              return;
            }

            console.log("SUBMISSION ALLOWED");

            this.sendToSkatteverket();
          }
        );
      })
      .catch((error) => {
        console.error("Error checking maximum Skatteverket submission:", error);
      });
  };

  sendToSkatteverket = () => {
    this.setState({ loading: true });

    axios
      .post(
        "/xml/submitToSkatteverket?reportId=" + this.state.currentReportId,
        {},
        userSessionAuthKeyReturnValue
      )
      .then((response) => {
        this.handleSkatteverketSubmissionResponse(response.data);

        return axios.get(
          "/SRUHeader/getHeader?reportGuid=" + currentReportGUIDFromUrl,
          userSessionAuthKeyReturnValue
        );
      })
      .then((response) => {
        const latestHeaderResponse = response.data;

        console.log(
          "LATEST BACKEND COUNT:",
          latestHeaderResponse?.sendToSkatteverketCount
        );

        this.setState({
          headerResponse: latestHeaderResponse,
          skatteverketSubmissionCount:
            latestHeaderResponse?.sendToSkatteverketCount || 0,
          loading: false
        });
      })
      .catch((error) => {
        const errorResponse = error.response?.data;

        this.setState({
          loading: false,
          showConfirmReSubmitSkatteverketDialog: false,
          skatteverketResponse: errorResponse || {
            statusCode: 500,
            message: error.message || "Unknown error"
          },
          showSkatteverketDialog: true
        });
      });
  };

  showMaximumSubmissionDialog = () => {
    this.setState({
      showSkatteverketMaximumDialog: true
    });
  };

  hideMaximumSubmissionDialog = () => {
    this.setState({
      showSkatteverketMaximumDialog: false
    });
  };

  // axios(
  //   "/SRULines/downloadInfoSRUFile?reportID=" + currentReportId,
  //   userSessionAuthKeyReturnValue
  // ).then((response) => {

  // })
  // ;

  downloadInfoSRU = async () => {
    const { currentReportId } = this.state;
    if (userSessionAuthKeyReturnValue) {
      let localData = localStorage.getItem("rebelSkoolUser");
      let localObject = localData && JSON.parse(localData);
      try {
        // const response = await fetch(`/SRULines/downloadInfoSRUFile?reportID=${currentReportId}`);
        const sruHeaderResponse = await fetch(
          config.backend.url +
            "SRUHeader/getHeader?reportGuid=" +
            localStorage["sessionUUID"],
          {
            method: "GET",
            headers: {
              "User-Session-Auth-Key": localObject["User-Session-Auth-Key"]
            }
          }
        );

        const data = await sruHeaderResponse.json();

        console.log("sruHeader DATA", data);

        const fileName =
          data?.companyName && data?.currentYear
            ? `${data.companyName}_SRU_INFO_BLANKET_FY_${data.currentYear}`
            : "SRU_INFO_BLANKET";

        console.log("fileName:", fileName);

        const response = await fetch(
          config.backend.url +
            "SRULines/downloadInfoSRUFile?reportID=" +
            currentReportId,
          {
            method: "GET",
            headers: {
              // "Content-Type": "application/pdf",
              "User-Session-Auth-Key": localObject["User-Session-Auth-Key"]
            }
          }
        );
        if (!response.ok) {
          throw new Error("Failed to download file");
        }

        console.log("ALL HEADERS:", response.headers);
        console.log("File Headers", response.headers["content-disposition"]);

        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        // link.setAttribute("download", "files.zip"); // Specify the file name

        link.setAttribute("download", fileName); // Specify the file name
        document.body.appendChild(link);
        link.click();
        link.remove();
      } catch (error) {}
    }
  };

  editReport() {
    const incomeDeclaration2SRU = "/income-declaration-2/";
    this.props.history.push(
      incomeDeclaration2SRU + currentReportGUIDFromUrl + "/companyInfo"
    );
    window.location.reload(false);
  }

  sideBarCallback = (value) => {};
  sideBarStatus = (e) => {
    this.setState({
      sideBarStatus: e
    });
  };
  render() {
    const {
      checkoutId,
      checkoutPurchaseId,
      checkoutAmount,
      showPayementSuccessModal,
      showNotification,
      loading,
      infoFile,
      blanketFile,
      infoFileText,
      showSkatterverketButton,
      showConfirmReSubmitSkatteverketDialog,
      headerResponse
    } = this.state;

    console.log("PROPS KEYS:", Object.keys(this.props));
    console.log("STATE KEYS:", Object.keys(this.state));

    const apiErrorMessage = [
      this.state.skatteverketResponse?.message,
      this.state.skatteverketResponse?.support
    ]
      .filter(Boolean)
      .join("\n\n");

    return (
      <div className="SRU-notes-main-div">
        <Tooltip
          target=".sru-copy-icon , .sru-blanket-copy-icon"
          position="top"
        />
        <Toast
          ref={(el) => {
            this.toast = el;
          }}
          style={{ marginTop: "80px" }}
        ></Toast>
        <Helmet>
          <meta charSet="utf-8" />
          <title>
            {userSelectedLanguage == "sw"
              ? TranslationFile.FaviconAppText[userSelectedLanguage]
              : TranslationFile.FaviconAppText.en}
          </title>
        </Helmet>

        <SRUNavBarHeader
          callBack={this.callback}
          isAppPortal={true}
          isHomePage={false}
        />

        <div className="paymentSideBar">
          <Sidebar
            children="Review And Send"
            sideBarStatus={this.sideBarStatus.bind(this)}
            sideBarCallback={(e) => this.sideBarCallback(e)}
            selectedForms={this.state.SelectedSRUForm2}
            organizationNumber={this.state.organizationNumber}
            companyName={this.state.companyName}
            city={this.state.city}
            postalCode={this.state.postalCode}
            currentYear={this.state.currentYear}
            currentFromDate={this.state.currentFromDate}
            currentToDate={this.state.currentToDate}
            SelectedSRUForm2={this.state.SelectedSRUForm2}
          />
        </div>
        <ConfirmPopup />
        <div
          className="SRU-reviewAndSendPaymentSuccess"
          style={{ display: showNotification ? "inherit" : "none" }}
        >
          <Messages ref={(el) => (this.msgs1 = el)} />
        </div>

        {loading ? (
          <div className="sru-loading-container">
            <ProgressSpinner
              style={{ width: "50px", height: "50px" }}
              strokeWidth="4"
              animationDuration=".5s"
            />
          </div>
        ) : (
          <div className="SRU-reviewAndSend-div">
            <div className="SRU-review-edit">
              {/* <Row>
              <Col xl={10} style={{ textAlign: "center", paddingTop: "3px" }}>
                <h5>
                  Kindly Review the SRU file and send the report to Skatteverket
                </h5>
              </Col>
              <Col>
                <Button
                  label="Edit Report"
                  icon="pi pi-pencil"
                  onClick={() => this.editReport()}
                />
              </Col>
            </Row> */}
            </div>
            <center>
              {/* <div
              style={{ textAlign: "left", marginLeft: "10%", color: "blue" }}
            >
              <Button
                icon="pi pi-download"
                label={
                  TranslationFile.downloadSRUPackagesInfoBlanket[
                    userSelectedLanguage
                  ]
                }
                onClick={() => this.downloadInfoSRU()}
                style={{
                  marginBottom: "12px",
                  background: "#FF7A00"
                }}
              />
            </div> */}

              <Card className="mb-3 review-send-card sru-review-card info-sru-card">
                <div className="sru-info-div">
                  {/* Header */}
                  <div className="sru-info-header">
                    <div className="sru-file-title">
                      {/* <i className="pi pi-file"></i> */}
                      <strong>INFO.SRU</strong>
                    </div>

                    <i
                      className="pi pi-copy sru-copy-icon"
                      onClick={this.copyToClipboardInfo}
                      data-pr-tooltip={
                        TranslationFile.copy[userSelectedLanguage]
                      }
                      data-pr-position="top-right"
                      role="button"
                      tabIndex="0"
                    ></i>
                  </div>

                  {/* File Content */}
                  <div className="sru-info-content">
                    {infoFile &&
                      infoFile.map((line, index) => (
                        <div
                          key={index}
                          className="blanket-line"
                          style={{
                            animationDelay: `${index * 20}ms`
                          }}
                        >
                          <div className="blanket-line-number">{index + 1}</div>

                          <div className="blanket-line-text">{line}</div>
                        </div>
                      ))}
                  </div>
                </div>
              </Card>
            </center>
            {/* <br></br> */}
            <center>
              <Card className="mb-3 review-send-card sru-review-card blanket-sru-card">
                <div className="sru-info-div">
                  {/* Header */}
                  <div className="sru-info-header">
                    <div className="sru-file-title">
                      {/* <i className="pi pi-file"></i> */}
                      <strong>
                        {
                          TranslationFile.blanketSRULableText[
                            userSelectedLanguage
                          ]
                        }
                      </strong>
                    </div>

                    <i
                      className="pi pi-copy sru-blanket-copy-icon"
                      onClick={this.copyToClipboardBlanket}
                      data-pr-tooltip={
                        TranslationFile.copy[userSelectedLanguage]
                      }
                      data-pr-position="top"
                      role="button"
                      tabIndex="0"
                    ></i>
                  </div>

                  {/* File Content */}
                  <div className="sru-info-content">
                    {blanketFile &&
                      blanketFile.map((line, index) => (
                        <div
                          key={index}
                          className="blanket-line"
                          style={{
                            animationDelay: `${index * 30}ms`
                          }}
                        >
                          <div className="blanket-line-number">{index + 1}</div>

                          <div className="blanket-line-text">{line}</div>
                        </div>
                      ))}
                  </div>
                </div>
              </Card>
              <div
                style={{
                  textAlign: "center",
                  marginLeft: "0",
                  marginTop: "10%",
                  color: "blue"
                }}
              >
                <Button
                  icon="pi pi-download"
                  label={
                    TranslationFile.downloadSRUPackagesInfoBlanket[
                      userSelectedLanguage
                    ]
                  }
                  onClick={() => this.downloadInfoSRU()}
                  // className="submitToBolagsverketBtn"
                  style={{
                    marginBottom: "12px",
                    background: "#4e8ed9"
                  }}
                />
              </div>
              {/* {showSkatterverketButton && (
                <div className="SRU-review-submit">
                  <Button
                    label={
                      Number(
                        this.state.headerResponse?.sendToSkatteverketCount
                      ) > 0
                        ? TranslationFile.reSubmit[userSelectedLanguage]
                        : TranslationFile.IncomeDeclaration2Submit[
                            userSelectedLanguage
                          ]
                    }
                    icon="pi pi-send"
                    onClick={this.sendToSkatteverket}
                    className="submitToBolagsverketBtn"
                    disabled={linkSharedUser == 2 || linkSharedUser == 3}
                  />

                  <ConfirmDialog
                    group="declarative"
                    visible={this.state.showConfirmReSubmitSkatteverketDialog}
                    onHide={() => {
                      this.setState({
                        showConfirmReSubmitSkatteverketDialog: false
                      });
                    }}
                    message="This report has already been submitted to Skatteverket. Do you want to submit it again?"
                    header="Confirmation"
                    icon="pi pi-exclamation-triangle"
                    accept={() => {
                      this.sendToSkatteverket();
                    }}
                    reject={() => {
                      this.setState({
                        showConfirmReSubmitSkatteverketDialog: false
                      });
                    }}
                  />

                  <Dialog
                    header="Maximum Submission Limit Reached"
                    visible={this.state.showSkatteverketMaximumDialog}
                    modal
                    closable={false}
                    draggable={false}
                    resizable={false}
                    style={{ width: "35rem" }}
                    onHide={this.hideMaximumSubmissionDialog}
                  >
                    <div
                      style={{
                        lineHeight: "1.8",
                        fontSize: "15px"
                      }}
                    >
                      <p>
                        This report has reached the maximum number of
                        submissions allowed to Skatteverket.
                      </p>

                      <p>
                        <strong>
                          Submissions: {this.state.skatteverketSubmissionCount}{" "}
                          / {this.state.maximumSkatteverketSubmissionCount}
                        </strong>
                      </p>

                      <div
                        style={{
                          marginTop: "20px",
                          textAlign: "right"
                        }}
                      >
                        <Button
                          label="Close"
                          icon="pi pi-check"
                          onClick={this.hideMaximumSubmissionDialog}
                        />
                      </div>
                    </div>
                  </Dialog>
                </div>
              )} */}
              {Number(headerResponse?.sendToSkatteverketCount) > 0 &&
                headerResponse.latestSkatteverketSubmissionDateTime && (
                  <div>
                    <p>
                      <i
                        className="pi pi-exclamation-circle"
                        id="reportAlreadySubmittedExclamationIcon"
                      ></i>
                      {
                        TranslationFile.reportAlreadySubmittedSKV[
                          userSelectedLanguage
                        ]
                      }{" "}
                      <b>
                        {moment(
                          headerResponse.latestSkatteverketSubmissionDateTime
                        ).format("YYYY-MM-DD HH:mm:ss.SS")}
                      </b>
                    </p>
                  </div>
                )}
              {showSkatterverketButton &&
                linkSharedUser !== 3 &&
                linkSharedUser !== 4 && (
                  <div className="SRU-review-submit">
                    {/* Terms & Conditions */}
                    <div style={{ marginBottom: "15px" }}>
                      <Checkbox
                        inputId="skatteverketTerms"
                        checked={this.state.acceptedSkatteverketTerms}
                        onChange={(e) =>
                          this.setState({
                            acceptedSkatteverketTerms: e.checked
                          })
                        }
                      />

                      <span style={{ marginLeft: "8px" }}>
                        {TranslationFile.ReviewAcceptText[userSelectedLanguage]}
                      </span>

                      <span>
                        <a
                          className="classcolourterm"
                          href={config.corporatePage.url + "terms-of-usage"}
                          target="_blank"
                          rel="noreferrer"
                          style={{ marginLeft: "4px" }}
                        >
                          {TranslationFile.loginTermsText[userSelectedLanguage]}
                        </a>
                      </span>
                    </div>

                    {linkSharedUser !== 3 && linkSharedUser !== 4 && (
                      <Button
                        label={
                          Number(
                            this.state.headerResponse?.sendToSkatteverketCount
                          ) > 0
                            ? TranslationFile.reSubmit[userSelectedLanguage]
                            : TranslationFile.submitToSkatteverket[
                                userSelectedLanguage
                              ]
                        }
                        icon="pi pi-send"
                        onClick={this.handleSendToSkatteverket}
                        className="submitToBolagsverketBtn"
                        disabled={
                          linkSharedUser == 2 ||
                          linkSharedUser == 3 ||
                          !this.state.acceptedSkatteverketTerms
                        }
                      />
                    )}

                    {/* Resubmit Confirmation */}
                    <ConfirmDialog
                      group="declarative"
                      visible={this.state.showConfirmReSubmitSkatteverketDialog}
                      onHide={() => {
                        this.setState({
                          showConfirmReSubmitSkatteverketDialog: false
                        });
                      }}
                      message={
                        TranslationFile.ResumbitConfirmSKVText[
                          userSelectedLanguage
                        ]
                      }
                      header={
                        TranslationFile.confirmation[userSelectedLanguage]
                      }
                      icon="pi pi-exclamation-triangle"
                      accept={() => {
                        this.setState(
                          {
                            showConfirmReSubmitSkatteverketDialog: false
                          },
                          () => {
                            this.checkMaximumSubmission();
                          }
                        );
                      }}
                      reject={() => {
                        this.setState({
                          showConfirmReSubmitSkatteverketDialog: false
                        });
                      }}
                    />

                    {/* Maximum Submission Limit */}
                    <Dialog
                      header="Maximum Submission Limit Reached"
                      visible={this.state.showSkatteverketMaximumDialog}
                      modal
                      closable={false}
                      draggable={false}
                      resizable={false}
                      style={{ width: "35rem" }}
                      onHide={this.hideMaximumSubmissionDialog}
                    >
                      <div
                        style={{
                          lineHeight: "1.8",
                          fontSize: "15px"
                        }}
                      >
                        <p>
                          This report has reached the maximum number of
                          submissions allowed to Skatteverket.
                        </p>

                        <p>
                          <strong>
                            Submissions:{" "}
                            {this.state.skatteverketSubmissionCount} /{" "}
                            {this.state.maximumSkatteverketSubmissionCount}
                          </strong>
                        </p>

                        <div
                          style={{
                            marginTop: "20px",
                            textAlign: "right"
                          }}
                        >
                          <Button
                            label="Close"
                            icon="pi pi-check"
                            onClick={this.hideMaximumSubmissionDialog}
                          />
                        </div>
                      </div>
                    </Dialog>
                  </div>
                )}
              {showSkatterverketButton && (
                <Dialog
                  header={
                    this.state.skatteverketResponse?.statusCode === 200
                      ? `✅ ${
                          TranslationFile.IncomeDeclaration2Success[
                            userSelectedLanguage
                          ].split("\n\n")[0]
                        }`
                      : TranslationFile.IncomeDeclaration2Failed[
                          userSelectedLanguage
                        ].split("\n\n")[0]
                  }
                  visible={this.state.showSkatteverketDialog}
                  modal
                  closable
                  draggable={false}
                  resizable={false}
                  style={{ width: "40rem" }}
                  onHide={() =>
                    this.setState({
                      showSkatteverketDialog: false,
                      skatteverketResponse: {}
                    })
                  }
                >
                  {this.state.skatteverketResponse?.statusCode === 200 ? (
                    /* ================= SUCCESS ================= */
                    <div
                      style={{
                        lineHeight: "1.8",
                        fontSize: "15px"
                      }}
                    >
                      {(() => {
                        const text =
                          TranslationFile.IncomeDeclaration2Success[
                            userSelectedLanguage
                          ].split("\n\n");

                        return (
                          <>
                            <p>{text[1]}</p>

                            <p>{text[2]}</p>

                            <p>
                              {text[3]}
                              <br />

                              <a
                                href={this.state.skatteverketResponse?.url}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  wordBreak: "break-all"
                                }}
                              >
                                {this.state.skatteverketResponse?.url}
                              </a>
                            </p>

                            <p>{text[4]}</p>

                            <p>
                              <strong>{text[5]}</strong>{" "}
                              {this.state.skatteverketResponse?.mottaget}
                            </p>
                          </>
                        );
                      })()}
                    </div>
                  ) : (
                    /* ================= FAILURE ================= */
                    <div
                      style={{
                        lineHeight: "1.8",
                        fontSize: "15px"
                      }}
                    >
                      {/* Translated failure message */}
                      <div
                        style={{
                          whiteSpace: "pre-line"
                        }}
                      >
                        {
                          TranslationFile.IncomeDeclaration2Failed[
                            userSelectedLanguage
                          ]
                        }
                      </div>

                      {/* ================= ERROR MESSAGE ================= */}
                      {this.state.skatteverketResponse?.errors?.length > 0 && (
                        <div style={{ marginTop: "20px" }}>
                          <strong>Error message:</strong>

                          <div
                            style={{
                              marginTop: "8px",
                              padding: "12px",
                              border: "1px solid #ddd",
                              borderRadius: "4px",
                              background: "#f8f8f8",
                              whiteSpace: "pre-wrap",
                              wordBreak: "break-word"
                            }}
                          >
                            {this.state.skatteverketResponse.errors
                              .map((error) => error?.detail)
                              .filter(Boolean)
                              .join("\n\n")}
                          </div>
                        </div>
                      )}

                      {/* ================= TECHNICAL ERROR ================= */}
                      {this.state.skatteverketResponse?.errorType ===
                        "TECHNICAL_ERROR" && (
                        <div style={{ marginTop: "20px" }}>
                          <strong>Technical Error</strong>

                          <p style={{ marginTop: "8px" }}>
                            {this.state.skatteverketResponse?.support}
                          </p>

                          {this.state.skatteverketResponse?.logErrorGUID && (
                            <p>
                              <strong>Log Error GUID:</strong>{" "}
                              {this.state.skatteverketResponse.logErrorGUID}
                            </p>
                          )}
                        </div>
                      )}

                      {/* ================= COPY ERROR MESSAGE ================= */}
                      <div style={{ marginTop: "15px" }}>
                        <Button
                          label="Copy Error Message"
                          icon="pi pi-copy"
                          onClick={() => {
                            const response = this.state.skatteverketResponse;

                            // const errorText =
                            //   response?.errors
                            //     ?.map((error) => error?.detail)
                            //     .filter(Boolean)
                            //     .join("\n\n") ||
                            //   response?.message ||
                            //   "";

                            const errorText = response
                              ? JSON.stringify(response, null, 2)
                              : "";

                            navigator.clipboard
                              .writeText(errorText)
                              .then(() => {
                                this.setState({
                                  errorMessageCopied: true
                                });

                                setTimeout(() => {
                                  this.setState({
                                    errorMessageCopied: false
                                  });
                                }, 2000);
                              })
                              .catch((err) => {
                                console.error("COPY FAILED:", err);
                              });
                          }}
                        />

                        {this.state.errorMessageCopied && (
                          <span
                            style={{
                              marginLeft: "10px"
                            }}
                          >
                            Error message copied
                          </span>
                        )}
                      </div>

                      {/* ================= COLLAPSED TECHNICAL DETAILS ================= */}
                      <details style={{ marginTop: "20px" }}>
                        <summary
                          style={{
                            cursor: "pointer",
                            fontWeight: "600"
                          }}
                        >
                          Technical details
                        </summary>

                        <div
                          style={{
                            marginTop: "10px",
                            padding: "12px",
                            border: "1px solid #ddd",
                            borderRadius: "4px",
                            background: "#f8f8f8",
                            whiteSpace: "pre-wrap",
                            wordBreak: "break-word",
                            fontFamily: "monospace",
                            fontSize: "13px",
                            maxHeight: "250px",
                            overflowY: "auto"
                          }}
                        >
                          {JSON.stringify(
                            this.state.skatteverketResponse,
                            null,
                            2
                          )}
                        </div>
                      </details>
                    </div>
                  )}

                  {/* ================= CLOSE BUTTON ================= */}
                  <div
                    style={{
                      marginTop: "20px",
                      textAlign: "right"
                    }}
                  >
                    <Button
                      label={
                        TranslationFile.Close?.[userSelectedLanguage] || "Close"
                      }
                      icon="pi pi-check"
                      onClick={() =>
                        this.setState({
                          showSkatteverketDialog: false,
                          skatteverketResponse: {}
                        })
                      }
                    />
                  </div>
                </Dialog>
              )}
            </center>
          </div>
        )}

        <ScrolltoTop />
        <Footer_contact_tab
          className="ReviewandSend-footer-contact"
          sideBar={this.state.sideBarStatus}
          isCorpPortal={false}
          isHomePage={true}
        />
      </div>
    );
  }
}
export default connect(mapStateToProps, null)(SRUReviewAndSend);
